import Head from 'next/head'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import { useAccount } from 'wagmi'

import Button from '../../components/Button'
// import LoaderDots from '../../components/LoaderDots'
import AnimatedLine from '../../components/Home/AnimatedLine'
import { CodeIcon, ExternalLinkIcon, SearchIcon, XCircleIcon } from '../../components/Icons'
import { Transactions } from '../../components/Layout/Account/Transactions'
import { Loader } from '../../components/Loader'
import { Tooltip } from '../../components/Tooltip'
import { useSessionChainId } from '../../state/application/hooks'
import { useNotifications } from '../../state/user/hooks'
import useActiveWeb3React from '../../wagmi/hooks/useActiveWeb3React'

/**
 * Home Page of the Application
 * @return {JSX.Element}
 */
export default function Home(): JSX.Element {
  const { t } = useTranslation()
  const [chainIdcurrent] = useSessionChainId()
  const { chainId, chain } = useActiveWeb3React()
  const {address} = useAccount()
  const [notfications, {clearNotifications}] = useNotifications(address)
  return (
    <>
      <Head>
        <title>Home | EmberSwap</title>
        <meta name="description" content="EmberSwap" />
      </Head>
      <div className="grid max-w-screen-xl grid-cols-1 gap-2 p-4 m-auto z-2">
        <h2>
          {t('Welcome to EmberSwap')}
          <Loader.Spinner className="bg-green-400">asdaasda</Loader.Spinner>
          <Loader.Dots className="bg-green-400">asdaasda</Loader.Dots>
        </h2>
        <br />
        <Transactions notifications={notfications} clearNotifications={clearNotifications} />
        <div className="relative flex flex-row text-green-500 ">
          <Tooltip
            placement="right"
            panel={<>2131231231231231312312312312</>}
            button={<div className="text-red-500 bg-green-500">test</div>}
          />
          <Button className="relative z-[5]" size="md" variant="outlined" color="red">
            tssest
            <div className=" left-0 right-0 z-[2] w-full absolute bg-gradient-to-tl from-yellow-400/70 transition-all duration-1000 via-orange-500/70 to-red-600/70 bg-pos-0 bg-size-200 hover:bg-pos-100 h-[52px] rounded-2xl" />
          </Button>
        </div>
        <br />
        <div>{chainIdcurrent}</div>
        <div></div>
        <div>{chainId}</div>
        {new Date().getFullYear()}
        <br />
        {new Date().getMonth()}
        <br />
        {new Date().getDay()}
        <br />
        {new Date().getHours()}
        <br />
        {new Date().getMinutes()}
        <br />
        {new Date().getSeconds()}
        <br />
        {JSON.stringify(new Date())}
        <br />
        <div>{JSON.stringify(chain)}</div>
        <br />
        <SearchIcon />
        <XCircleIcon />
        <ExternalLinkIcon />{' '}
        <CodeIcon width={20} height={20} className="text-gray-100 hover:text-black" />
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam,
        illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem
        sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem
        ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a
        mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur
        adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod
        distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum
        dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus
        quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis
        corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione
        quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia
        eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse
        ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet
        consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas,
        quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem
        ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo
        delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit
        debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem
        ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a
        mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur
        adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod
        distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum
        dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus
        quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis
        corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione
        quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia
        eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse
        ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet
        consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas,
        quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem
        ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo
        delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit
        debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem
        ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a
        mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur
        adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod
        distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum
        dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus
        quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis
        corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione
        quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia
        eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse
        ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet
        consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas,
        quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem
        ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo
        delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit
        debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem
        ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a
        mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur
        adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod
        distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum
        dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus
        quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis
        corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione
        quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia
        eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Magnam, autem ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse
        ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet
        consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas,
        quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem
        ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo
        delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit
        debitis corporis? Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, autem
        ratione quisquam, illo delectus quia voluptas, quod distinctio dolorum esse ea? Ea id a
        mollitia eligendi. Rem sit debitis corporis? Lorem ipsum dolor sit amet consectetur
        adipisicing elit. Magnam, autem ratione quisquam, illo delectus quia voluptas, quod
        distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis corporis? Lorem ipsum
        dolor sit amet consectetur adipisicing elit. Magnam, autem ratione quisquam, illo delectus
        quia voluptas, quod distinctio dolorum esse ea? Ea id a mollitia eligendi. Rem sit debitis
        corporis?
        <Image
          src="https://emberswap.com/img/candlesticks2.png"
          alt="HEJ"
          className="w-full h-full"
          width={494}
          height={931}
        />
        <section className="one">
          <h1 className="scroll" data-rate=".4" data-direction="vertical">
            HALLO
          </h1>
        </section>
        <section className="two">
          <h1 className="scroll" data-rate=".2" data-direction="vertical"></h1>
          <p> big watermark</p>
        </section>
        <div className="flex items-center mb-4 font-medium text-red-900 title-font md:mb-0">
          TailWind CSS
        </div>
        <div className="randomtest tempcointainer"> SASS CSS</div>
        <h1 className="title">
          Welcome to <a href="https://nextjs.org">Next.js!</a>
        </h1>
        <p className="description">
          Get started by editing <code className="code">pages/index.js</code>
        </p>
        <div className="grid">
          <a href="https://nextjs.org/docs" className="card">
            <h3>Documentation &rarr;</h3>
            <p>Find in-depth information about Next.js features and API.</p>
          </a>
          <a href="https://nextjs.org/learn" className="card">
            <h3>Learn &rarr;</h3>
            <p>Learn about Next.js in an interactive course with quizzes!</p>
          </a>
          <a href="https://github.com/vercel/next.js/tree/master/examples" className="card">
            <h3>Examples &rarr;</h3>
            <p>Discover and deploy boilerplate example Next.js projects.</p>
          </a>
        </div>
      </div>
      <AnimatedLine />
    </>
  )
}
